import { createFileRoute } from "@tanstack/react-router";
import { StandardsPage } from "@/components/admin/standards/StandardsPage";

export const Route = createFileRoute("/$workspaceSlug/admin/standards/")({
  component: StandardsPage,
});
